export default __webpack_public_path__ + "static/media/plan-savings.6348f0b8.png";